/* 🤖 this file was generated by script */
export const wiconWifiOff = {
  name: 'wifi_off',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.31 10a11 11 0 013.77 2.05m3.5-3.55A16 16 0 0010.2 4.6M8.53 15.61a6 6 0 016.95 0M12 19.5h.01M1.19 8.7a16.01 16.01 0 014.57-2.94m-1.03 6.48a10.97 10.97 0 015-2.5m5.97 6.04a5.97 5.97 0 00-7.44.03M3 3l18 18"/></svg>`,
};
